import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { VehicleDirectivesModule } from "@app/directives/_vehicle/_vehicle.directives.module";
import { VisualisationsModule } from "@app/directives/_visualisations/visualisations.module";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { ResourceFiltersDirectivesModule } from "@directives/_resourceFilters/_resourceFilters.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { providerCreator } from "@services/_services.module";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { VReportColumnSelectorComponent } from "./reportBuilder/report-column-selector/report-column-selector.component";
import { VReportColumnComponent } from "./reportBuilder/report-column/report-column.component";
import { VTableColumnSelectorComponent } from "./reportBuilder/table-column-selector/table-column-selector.component";
import { VDrillDownReportTableComponent } from "./_components/drill-down-report-table/drill-down-report-table.component";
import { GroupsModule } from "../resourceManagement/groups/groups.module";
import { ReportCardComponent } from "./_components/report-card/report-card.component";
import { ReportCategorySelectorComponent } from "./_components/report-category-selector/report-category-selector.component";
import { FilterTitleRowColumnHeaderPipe, ReportColumnHeadersSelectorComponent } from "./_components/report-column-headers-selector/report-column-headers-selector.component";
import { ReportEditorComponent } from "./_components/report-editor/report-editor.component";
import { ReportFiltersComponent } from "./_components/report-filters/report-filters.component";
import { ReportInternationalisationOptionsComponent } from "./_components/report-internationalisation-options/report-internationalisation-options.component";
import { ReportParametersComponent } from "./_components/report-parameters/report-parameters.component";
import { ReportScheduleEditorComponent } from "./_components/report-schedule-editor/report-schedule-editor.component";
import { ReportSchedulesComponent } from "./_components/report-schedules/report-schedules.component";
import { VReportTableComponent } from "./_components/report-table/report-table.component";
import { ReportTitleComponent } from "./_components/report-title/report-title.component";
import { RowDataSourceSelectorComponent2 } from "./_components/row-data-source-selector2/row-data-source-selector2.component";
import { ReportHistoryPageComponent } from "./_routes/report-history-page/report-history-page.component";
import { ReportHistoryViewComponent } from "./_routes/report-history-view/report-history-view.component";
import { ReportListPageComponent } from "./_routes/report-list-page/report-list-page.component";
import { ReportSchedulePageComponent } from "./_routes/report-schedule-page/report-schedule-page.component";
import { ReportViewComponent } from "./_routes/report-view/report-view.component";
import { DynamicReportService } from "./_services/dynamicReports.service";

const privateComponents: any[] = [

];

const publicComponents: any[] = [
    ReportViewComponent,
    ReportSchedulePageComponent,
    ReportListPageComponent,
    ReportHistoryPageComponent,

    ReportTitleComponent,
    ReportFiltersComponent,
    ReportColumnHeadersSelectorComponent,
    ReportParametersComponent,
    ReportCardComponent,
    ReportCategorySelectorComponent,
    ReportSchedulesComponent,
    ReportScheduleEditorComponent,
    ReportEditorComponent,
    ReportInternationalisationOptionsComponent,
    RowDataSourceSelectorComponent2,
    ReportHistoryViewComponent,
    VTableColumnSelectorComponent,
    VReportTableComponent,
    VDrillDownReportTableComponent,
    VReportColumnComponent,
    VReportColumnSelectorComponent

];

const declarations: any[] = [
    FilterTitleRowColumnHeaderPipe
];

const providers: any[] = [
    providerCreator(DynamicReportService, "dynamicReportService")
];

@NgModule({
    imports: [
        CommonModule,
        DragDropModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,

        PipesModule,
        LayoutDirectivesModule,
        VeriDirectivesModule,
        MiscDirectivesModule,
        FormsDirectivesModule,
        CoreDirectivesModule,
        VisualisationsModule,
        ResourceFiltersDirectivesModule,
        VTableModule,
        VehicleDirectivesModule,
        GroupsModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReportsModule {
    constructor() {
    }
}
